export const getFormattedTextOrDefault = (formatter, noValue = () => '-') => text => {
  if (text !== undefined && text !== null) {
    return formatter(text)
  }

  return noValue()
}

export const getPrintedPostalCode = postalCode => {
  if (!postalCode) {
    return ''
  }
  if (postalCode.length === 5) {
    return postalCode
  }
  const start = postalCode.substr(0, 5)
  const end = postalCode.substr(5, postalCode.length)

  return `${start}-${end}`
}
